module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t1_ba1_disable.99f7a43f.svg";